import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { getAllTenantCurrenciesStart } from '../../../../store/redux-slices/currencies'
import { getTenantCountriesStart } from '../../../../store/redux-slices/fetchData'
import { getAllTenantTransactionsStart } from '../../../../store/redux-slices/tenantTransactions'
import { getDateDaysAgo, formatDateYMD } from '../../../../utils/dateFormatter'
import { getItem } from '../../../../utils/storageUtils'
import useDidMountEffect from '../../../../utils/useDidMountEffect'
import { getTransactionPaymentCategoriesStart, getTransactionReportingPaymentCategoriesStart } from '../../../../store/redux-slices/payment'
import { getSuperAdminAllTransactionsStart } from '../../../../store/redux-slices/superAdminTransactions'
import { getTransactionSortedValues } from '../../../../utils/constants'
import { getLicenseListStart } from '../../../../store/redux-slices/licenseManagement'
import { getAllTenantsListStart } from '../../../../store/redux-slices/tenants'
import { TABLE_IDS } from '../../../../constants/table'

const useTransactionBList = ({ isUserDetail, allTransaction = false }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { userId } = useParams()
  const { user } = useSelector((state) => state.tenantUsers)
  const { tenantsList } = useSelector((state) => state.tenants)
  const [selectedCurrency, setSelectedCurrency] = useState('')
  const [transactionId, setTransactionId] = useState('')
  const [selectedAction, setSelectedAction] = useState(JSON.stringify([]))
  const [limit, setLimit] = useState(15)
  const [page, setPage] = useState(1)
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('')
  const [kycStatus, setKycStatus] = useState('')
  const [myUserId, setMyUserId] = useState(userId || '')
  const [selectedCountry, setSelectedCountry] = useState('')
  const [paymentMethod, setPaymentMethod] = useState('[]')
  const [transactionsSortBy, setTransactionsSortBy] = useState({
    id: '',
    paymentId: '',
    targetId: '',
    trxSuccess: '',
    trxDecline: '',
    mdr: '',
    pspFee: '',
    primaryCurrencyAmount: '',
    isSortingField: null
  })
  const [transactionHover, setTransactionHover] = useState({
    id: false,
    paymentId: false,
    targetId: false,
    trxSuccess: false,
    trxDecline: false,
    mdr: false,
    pspFee: false,
    primaryCurrencyAmount: false
  })
  const { tenantDetails } = useSelector((state) => state.login)
  const { loading, tenantTransactions } = useSelector((state) => state.tenantTransactions)
  const { tenantCountries: countries } = useSelector(state => state.fetch)
  const totalPages = Math.ceil(tenantTransactions?.count / limit)
  const [selectedPaymentProvider, setSelectedPaymentProvider] = useState('[]')
  const isInitialRender = useDidMountEffect()
  const { transactionPaymentCategories, transactionReportingPaymentCategories } = useSelector((state) => state.payment)
  const { allTransactions } = useSelector((state) => state.superAdminTransactions)
  const allTransactionsTotalPages = Math.ceil(allTransactions?.count / limit)
  const [check, setCheck] = useState({ createdAt: false, updatedAt: true })
  const [selectedLicense, setSelectedLicense] = useState('')
  const { licenseList } = useSelector((state) => state.licenseManagement)
  const { tenantDetails: loginTenantDetails } = useSelector((state) => state.login)
  const [selectedTenants, setSelectedTenants] = useState([])
  const financialColumnSelectionsFromStore = useSelector((state) => state?.uiConfig?.tableColumnSelections[TABLE_IDS.FINANCIAL_TRANSACTIONS] || [])

  const [sortBy, setSortBy] = useState({
    amount: 'desc',
    Id: 'desc',
    isAmountSorting: null
  })

  const [over, setOver] = useState({
    amount: false,
    Id: false
  })

  const [state, setState] = useState([
    {
      startDate: getDateDaysAgo(10),
      endDate: new Date(),
      key: 'selection'
    }
  ])

  const [createdAt, setCreatedAt] = useState([
    {
      startDate: getDateDaysAgo(10),
      endDate: new Date(),
      key: 'selection'
    }
  ])

  useEffect(() => {
    if (selectedTenants.length) {
      dispatch(
        getLicenseListStart({
          isMulti: true,
          tenantIds: JSON.stringify(selectedTenants?.map((tenant) => tenant.value))
        })
      )
    } else if (loginTenantDetails?.tenantId) {
      dispatch(
        getLicenseListStart({
          tenantId: loginTenantDetails?.tenantId || ''
        })
      )
    }
  }, [selectedTenants])

  useEffect(() => {
    dispatch(getAllTenantCurrenciesStart({ limit: '', pageNo: '' }))
    dispatch(getTenantCountriesStart())
    dispatch(getTransactionPaymentCategoriesStart({ isTenant: true, adminId: isUserDetail ? user?.adminId : '', tenantId: isUserDetail ? user?.tenantId : '' }))
    dispatch(getTransactionReportingPaymentCategoriesStart({ isTenant: true, adminId: isUserDetail ? user?.adminId : '', tenantId: isUserDetail ? user?.tenantId : '' }))
    dispatch(getAllTenantsListStart())
  }, [])

  const getCsvDownloadUrl = (value) => {
    const financialExcludedColumns = financialColumnSelectionsFromStore.filter(column => !column.show).map(column => column.id)
    if (value === 'player') {
      return `${process.env.REACT_APP_API_URL}/api/tenant/transactions?csvDownload=true&limit=${limit}&pageNo=${page}&actioneeType=${search}${check.createdAt ? `&createdAtStartDate=${formatDateYMD(createdAt.map(a => a.startDate))}&createdAtEndDate=${formatDateYMD(createdAt.map(a => a.endDate))}` : ''}${check.updatedAt ? `&startDate=${formatDateYMD(state.map(a => a.startDate))}&endDate=${formatDateYMD(state.map(a => a.endDate))}` : ''}&transactionId=${transactionId}&currencyCode=${selectedCurrency}&transactionType=${selectedAction?.length ? selectedAction : '[]'}&paymentProvider=${selectedPaymentProvider}&status=${status}&kycStatus=${kycStatus}&parentLicenseId=${selectedLicense}&tenantId=${getItem('tenant-id')}&userId=${myUserId}&paymentMethod=${paymentMethod}`
    } else if (value === 'allTransactions') {
      return `${process.env.REACT_APP_API_URL}/api/tenant/transactions-all?csvDownload=true&limit=${limit}&pageNo=${page}&actioneeType=${search}${check.createdAt ? `&createdAtStartDate=${formatDateYMD(createdAt.map(a => a.startDate))}&createdAtEndDate=${formatDateYMD(createdAt.map(a => a.endDate))}` : ''}${check.updatedAt ? `&startDate=${formatDateYMD(state.map(a => a.startDate))}&endDate=${formatDateYMD(state.map(a => a.endDate))}` : ''}&transactionId=${transactionId}&currencyCode=${selectedCurrency}&transactionType=${selectedAction?.length ? selectedAction : '[]'}&tenantId=${tenantDetails?.tenantId}&adminId=${tenantDetails?.adminUserId}&paymentProvider=${selectedPaymentProvider}&status=${status}&kycStatus=${kycStatus}&parentLicenseId=${selectedLicense}&userId=${myUserId}&paymentMethod=${paymentMethod}`
    } else {
      if (selectedTenants?.length) {
        const tenantIds = JSON.stringify(selectedTenants.map((tenant) => tenant.value))
        return `${process.env.REACT_APP_API_URL}/api/tenant/transactions?csvDownload=true&limit=${limit}&pageNo=${page}&actioneeType=${search}${check.createdAt ? `&createdAtStartDate=${formatDateYMD(createdAt.map(a => a.startDate))}&createdAtEndDate=${formatDateYMD(createdAt.map(a => a.endDate))}` : ''}${check.updatedAt ? `&startDate=${formatDateYMD(state.map(a => a.startDate))}&endDate=${formatDateYMD(state.map(a => a.endDate))}` : ''}&transactionId=${transactionId}&currencyCode=${selectedCurrency}&transactionType=${selectedAction?.length ? selectedAction : '[]'}&paymentProvider=${selectedPaymentProvider}&status=${status}&kycStatus=${kycStatus}&parentLicenseId=${selectedLicense}&tenantIds=${tenantIds}&userId=${myUserId}&paymentMethod=${paymentMethod}`
      }

      return `${process.env.REACT_APP_API_URL}/api/tenant/transactions?csvDownload=true&limit=${limit}&pageNo=${page}&actioneeType=${search}${check.createdAt ? `&createdAtStartDate=${formatDateYMD(createdAt.map(a => a.startDate))}&createdAtEndDate=${formatDateYMD(createdAt.map(a => a.endDate))}` : ''}${check.updatedAt ? `&startDate=${formatDateYMD(state.map(a => a.startDate))}&endDate=${formatDateYMD(state.map(a => a.endDate))}` : ''}&transactionId=${transactionId}&currencyCode=${selectedCurrency}&transactionType=${selectedAction?.length ? selectedAction : '[]'}&paymentProvider=${selectedPaymentProvider}&status=${status}&kycStatus=${kycStatus}&parentLicenseId=${selectedLicense}&tenantId=${getItem('tenant-id')}&userId=${myUserId}&paymentMethod=${paymentMethod}&excludedColumns=${JSON.stringify(financialExcludedColumns)}`
    }
  }

  const getTransactionsCsvUrl = () => {
    if (selectedTenants.length) {
      const tenantIds = JSON.stringify(selectedTenants.map((tenant) => tenant.value))
      return `${process.env.REACT_APP_API_URL}/api/tenant/transactions-report?csvDownload=true&tenantIds=${tenantIds}${check.updatedAt ? `&startDate=${formatDateYMD(state.map(a => a.startDate))}&endDate=${formatDateYMD(state.map(a => a.endDate))}` : ''}`
    }

    return `${process.env.REACT_APP_API_URL}/api/tenant/transactions-report?csvDownload=true&tenantId=${tenantDetails?.tenantId || ''}${check.updatedAt ? `&startDate=${formatDateYMD(state.map(a => a.startDate))}&endDate=${formatDateYMD(state.map(a => a.endDate))}` : ''}`
  }

  const getParams = (myPage) => {
    const orderBy = getTransactionSortedValues[transactionsSortBy.isSortingField] || ''
    const { id, paymentId, targetId, trxSuccess, trxDecline, mdr, pspFee, primaryCurrencyAmount, isSortingField } = transactionsSortBy
    const sort = id || paymentId || targetId || trxSuccess || trxDecline || mdr || pspFee || primaryCurrencyAmount || isSortingField || 'desc'

    return {
      limit,
      pageNo: myPage,
      search,
      startDate: formatDateYMD(state.map(a => a.startDate)),
      endDate: formatDateYMD(state.map(a => a.endDate)),
      currencyId: selectedCurrency,
      transactionType: selectedAction,
      paymentProvider: selectedPaymentProvider,
      isUserDetail,
      userId: myUserId,
      status,
      kycStatus,
      licenseId: selectedLicense,
      countryCode: selectedCountry,
      transactionId,
      createdAtStartDate: formatDateYMD(createdAt.map(a => a.startDate)),
      createdAtEndDate: formatDateYMD(createdAt.map(a => a.endDate)),
      paymentMethod,
      check,
      orderBy,
      sort,
      orderType: sort,
      tenantIds: JSON.stringify(selectedTenants?.map((tenant) => tenant.value)),
      isMulti: Boolean(selectedTenants.length)
    }
  }

  useEffect(() => {
    !allTransaction
      ? dispatch(getAllTenantTransactionsStart({
        ...getParams(1)
      }))
      : dispatch(getSuperAdminAllTransactionsStart({
        ...getParams(page),
        tenantId: tenantDetails?.tenantId || '',
        adminId: tenantDetails?.adminUserId || '',
        isTenant: true
      }))
    setPage(1)
  }, [transactionsSortBy, limit, selectedCurrency, selectedCountry, selectedAction, state, search, status, kycStatus, selectedLicense, selectedPaymentProvider, sortBy, createdAt, paymentMethod, check, selectedTenants])

  useEffect(() => {
    if (!isInitialRender) {
      !allTransaction
        ? dispatch(getAllTenantTransactionsStart({
          ...getParams(page)
        }))
        : dispatch(getSuperAdminAllTransactionsStart({
          ...getParams(page),
          tenantId: tenantDetails?.tenantId || '',
          adminId: tenantDetails?.adminUserId || '',
          isTenant: true
        }))
    }
  }, [page])

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (!isInitialRender) {
        if (page === 1) {
          !allTransaction
            ? dispatch(getAllTenantTransactionsStart({
              ...getParams(page)
            }))
            : dispatch(getSuperAdminAllTransactionsStart({
              ...getParams(page),
              tenantId: tenantDetails?.tenantId || '',
              adminId: tenantDetails?.adminUserId || '',
              isTenant: true
            }))
        } else {
          setPage(1)
        }
      }
    }, 1000)

    return () => clearTimeout(delayDebounceFn)
  }, [transactionId, myUserId])

  return {
    wallets: null,
    setSelectedCurrency,
    setSearch,
    setLimit,
    setPage,
    totalPages,
    limit,
    page,
    setSelectedAction,
    navigate,
    selectedCurrency,
    selectedAction,
    search,
    state,
    setState,
    tenantTransactions,
    loading,
    selectedPaymentProvider,
    setSelectedPaymentProvider,
    getCsvDownloadUrl,
    tenantDetails,
    status,
    setStatus,
    kycStatus,
    setKycStatus,
    selectedCountry,
    setSelectedCountry,
    countries,
    transactionPaymentCategories,
    allTransactions,
    allTransactionsTotalPages,
    sortBy,
    setSortBy,
    over,
    setOver,
    userId,
    transactionId,
    setTransactionId,
    myUserId,
    setMyUserId,
    createdAt,
    setCreatedAt,
    transactionReportingPaymentCategories,
    paymentMethod,
    setPaymentMethod,
    check,
    setCheck,
    transactionsSortBy,
    setTransactionsSortBy,
    transactionHover,
    licenseList,
    selectedLicense,
    setSelectedLicense,
    getTransactionsCsvUrl,
    selectedTenants,
    setSelectedTenants,
    tenantsList
  }
}

export default useTransactionBList
